import { useState, useCallback, useLayoutEffect } from "react"

export const useTabHidden = () => {
  const [isTabHidden, setIsTabHidden] = useState(false)

  const handleVisibilityChange = useCallback(() => {
    setIsTabHidden(document.hidden)
  }, [])

  useLayoutEffect(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange)
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [handleVisibilityChange])

  return isTabHidden
}

export default useTabHidden
